import { analyticsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const getAdminEmbedLinkAction = catchAsyncActionError(() => async () => {
  const { data } = await analyticsApi.getAdminEmbedLink();

  return data;
});
